	
	const scroll_to_items = [...document.querySelectorAll('.js-scroll-to, a[href^="#"]')];

	scroll_to_items.forEach( function ( scroll_to_item ) {
		scroll_to_item.addEventListener( 'click', function ( event ) {
			const id_without_hash = scroll_to_item.href.split('#')[1];

			if ( id_without_hash ) {
				const target_element = document.querySelector( '#' + id_without_hash );

				if ( target_element ) {
					event.preventDefault();

					window.scrollTo( {
						top: target_element.offsetTop,
						left: 0,
						behavior: 'smooth',
					} );
				} else {
					console.error( "Target 'scroll-to' element doesnt exist." );
				}
			} else {
				console.error( "'scroll-to' item href is missing a viable ID." );
			}
		} );
	} );
